import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useMillAuth } from '../../contexts/MillAuthContext';
import WhatsNew from './WhatsNew';
import './MillHeader.css';


const MillHeader: React.FC = () => {
  const { user, logout } = useMillAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate('/mill/login');
  };

  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  const handleNavClick = () => {
    setMobileMenuOpen(false);
  };

  return (
    <header className="mill-header">
      <div className="mill-header-container">
        <div className="mill-header-left">
          <div className="mill-header-branding">
            <img src="/rbf-logo.png" alt="Red Bridge Farm Feed Co." className="mill-header-logo" />
            <div className="mill-header-brand-text">
              <div className="mill-header-company">Red Bridge Farm Feed Co.</div>
              <div className="mill-header-portal-label">Mill Portal</div>
            </div>
          </div>
          {user && (
            <nav className={`mill-header-nav ${mobileMenuOpen ? 'mobile-open' : ''}`}>
              <a
                href="/mill/command"
                target="_blank"
                rel="noopener noreferrer"
                className="mill-nav-link mill-nav-command"
                onClick={handleNavClick}
              >
                Command
              </a>
              <Link
                to="/mill/dashboard"
                className={`mill-nav-link ${isActive('/mill/dashboard') ? 'active' : ''}`}
                onClick={handleNavClick}
              >
                Dashboard
              </Link>
              <Link
                to="/mill/mixing"
                className={`mill-nav-link ${isActive('/mill/mixing') ? 'active' : ''}`}
                onClick={handleNavClick}
              >
                Mixing
              </Link>
              <Link
                to="/mill/packaging"
                className={`mill-nav-link ${isActive('/mill/packaging') ? 'active' : ''}`}
                onClick={handleNavClick}
              >
                Packaging
              </Link>
              <Link
                to="/mill/shipping"
                className={`mill-nav-link ${isActive('/mill/shipping') ? 'active' : ''}`}
                onClick={handleNavClick}
              >
                Shipping
              </Link>
              <Link
                to="/mill/orders"
                className={`mill-nav-link ${isActive('/mill/orders') ? 'active' : ''}`}
                onClick={handleNavClick}
              >
                Orders
              </Link>
              <Link
                to="/mill/calendar"
                className={`mill-nav-link ${isActive('/mill/calendar') ? 'active' : ''}`}
                onClick={handleNavClick}
              >
                Calendar
              </Link>
              <Link
                to="/mill/inventory"
                className={`mill-nav-link ${isActive('/mill/inventory') ? 'active' : ''}`}
                onClick={handleNavClick}
              >
                Raw Inventory
              </Link>
              <Link
                to="/mill/feed-bank"
                className={`mill-nav-link ${isActive('/mill/feed-bank') ? 'active' : ''}`}
                onClick={handleNavClick}
              >
                Feed Bank
              </Link>
              <Link
                to="/mill/labels"
                className={`mill-nav-link ${isActive('/mill/labels') ? 'active' : ''}`}
                onClick={handleNavClick}
              >
                Labels
              </Link>
            </nav>
          )}
        </div>
        {user && (
          <div className="mill-header-right">
            {user.can_access_admin_portal && (
              <button
                onClick={() => navigate('/dashboard')}
                className="mill-btn-portal-switch"
              >
                Admin Portal
              </button>
            )}
            {user.can_access_store_portal && (
              <button
                onClick={() => navigate('/store/dashboard')}
                className="mill-btn-portal-switch"
              >
                Store
              </button>
            )}
            <div className="mill-header-user-info">
              <div className="mill-header-welcome">Mill Worker</div>
              <div className="mill-header-username">
                {user.first_name ? `${user.first_name} ${user.last_name}` : user.username}
              </div>
              <div className="mill-header-role">{user.role_display}</div>
            </div>
            <span className="mill-header-whats-new"><WhatsNew portal="MILL" /></span>
            <button onClick={handleLogout} className="mill-btn-logout">
              Logout
            </button>
            {/* Hamburger Menu Button */}
            <button
              className={`mill-hamburger-btn ${mobileMenuOpen ? 'open' : ''}`}
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="Toggle navigation menu"
            >
              <span className="mill-hamburger-line"></span>
              <span className="mill-hamburger-line"></span>
              <span className="mill-hamburger-line"></span>
            </button>
          </div>
        )}
        {/* Mobile Menu with Portal Links */}
        {user && mobileMenuOpen && (
          <div className="mill-mobile-menu">
            <nav className="mill-mobile-nav">
              <Link to="/mill/dashboard" className={`mill-mobile-nav-link ${isActive('/mill/dashboard') ? 'active' : ''}`} onClick={handleNavClick}>
                Dashboard
              </Link>
              <Link to="/mill/mixing" className={`mill-mobile-nav-link ${isActive('/mill/mixing') ? 'active' : ''}`} onClick={handleNavClick}>
                Mixing
              </Link>
              <Link to="/mill/packaging" className={`mill-mobile-nav-link ${isActive('/mill/packaging') ? 'active' : ''}`} onClick={handleNavClick}>
                Packaging
              </Link>
              <Link to="/mill/shipping" className={`mill-mobile-nav-link ${isActive('/mill/shipping') ? 'active' : ''}`} onClick={handleNavClick}>
                Shipping
              </Link>
              <Link to="/mill/orders" className={`mill-mobile-nav-link ${isActive('/mill/orders') ? 'active' : ''}`} onClick={handleNavClick}>
                Orders
              </Link>
              <Link to="/mill/calendar" className={`mill-mobile-nav-link ${isActive('/mill/calendar') ? 'active' : ''}`} onClick={handleNavClick}>
                Calendar
              </Link>
              <Link to="/mill/inventory" className={`mill-mobile-nav-link ${isActive('/mill/inventory') ? 'active' : ''}`} onClick={handleNavClick}>
                Raw Inventory
              </Link>
              <Link to="/mill/feed-bank" className={`mill-mobile-nav-link ${isActive('/mill/feed-bank') ? 'active' : ''}`} onClick={handleNavClick}>
                Feed Bank
              </Link>
              <Link to="/mill/labels" className={`mill-mobile-nav-link ${isActive('/mill/labels') ? 'active' : ''}`} onClick={handleNavClick}>
                Labels
              </Link>
            </nav>
            <div className="mill-mobile-divider"></div>
            <div className="mill-mobile-portal-section">
              <div className="mill-mobile-section-label">Switch Portal</div>
              <a href="/dashboard" className="mill-mobile-portal-link mill-portal-admin" onClick={handleNavClick}>
                Admin Portal
              </a>
              <a href="/store/dashboard" className="mill-mobile-portal-link mill-portal-store" onClick={handleNavClick}>
                Store Portal
              </a>
              <a href="/portal/login" className="mill-mobile-portal-link mill-portal-customer" target="_blank" rel="noopener noreferrer" onClick={handleNavClick}>
                Customer Portal
              </a>
            </div>
            <div className="mill-mobile-divider"></div>
            <button onClick={handleLogout} className="mill-mobile-logout-btn">
              Logout
            </button>
          </div>
        )}
      </div>
      {/* Mobile Menu Overlay */}
      {mobileMenuOpen && (
        <div className="mill-mobile-overlay" onClick={() => setMobileMenuOpen(false)} />
      )}
    </header>
  );
};

export default MillHeader;
